"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const messagesMap_1 = __importDefault(require("../utils/messagesMap"));
const inversifySugarOptions_1 = __importDefault(require("../utils/inversifySugarOptions"));
function loggerMiddleware(planAndResolve) {
    return (args) => {
        const nextContextInterceptor = args.contextInterceptor;
        args.contextInterceptor = (context) => {
            if (inversifySugarOptions_1.default.debug) {
                console.log(messagesMap_1.default.resolveProvider(args.serviceIdentifier, context.container.id));
            }
            return nextContextInterceptor(context);
        };
        const result = planAndResolve(args);
        return result;
    };
}
exports.default = loggerMiddleware;
